import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { useData } from "@/context/DataContext";
import Seo from "@/components/site/Seo";
import { PageHero } from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import { WhatsAppButton } from "@/components/site/WhatsButton";

export default function Zones() {
  const { zones, settings, localPages } = useData();
  return (
    <>
      <Seo title="Zone servite — Provincia di Varese" description="Animaverde opera in provincia di Varese e comuni limitrofi: Ferno, Gallarate, Samarate, Cardano al Campo, Cassano Magnago, Busto Arsizio, Varese." path="/zone-servite" />
      <PageHero
        overline="Dove operiamo"
        title="Servizi per il verde in provincia di Varese"
        subtitle="Animaverde opera in provincia di Varese e nei comuni limitrofi, offrendo servizi di manutenzione, potatura, abbattimento, trattamento e realizzazione di giardini."
        breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <span className="text-av-white">Zone servite</span></>}
      />

      <section className="bg-av-black py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {zones.map((z, i) => {
              const hasPage = (localPages || []).some((lp) => lp.slug === z.slug);
              const inner = (
                <>
                  <MapPin size={20} className="text-av-bright mb-3 group-hover:text-av-lime transition-colors" />
                  <h2 className="font-display text-xl text-av-white">{z.nome}</h2>
                  {hasPage && <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-av-lime">Scopri i servizi →</span>}
                </>
              );
              return (
                <Reveal key={z.id} delay={(i % 4) * 0.06}>
                  {hasPage ? (
                    <Link to={`/giardiniere/${z.slug}`} data-testid={`zone-${z.slug}`} className="group block rounded-2xl border border-white/10 bg-av-green-dark/40 p-6 hover:border-av-lime/50 transition-colors" style={{ backgroundColor: "rgba(22,56,29,0.35)" }}>
                      {inner}
                    </Link>
                  ) : (
                    <div data-testid={`zone-${z.slug}`} className="group rounded-2xl border border-white/10 bg-av-green-dark/40 p-6 hover:border-av-lime/50 transition-colors" style={{ backgroundColor: "rgba(22,56,29,0.35)" }}>
                      {inner}
                    </div>
                  )}
                </Reveal>
              );
            })}
          </div>

          <div className="mt-14 rounded-3xl border border-white/10 p-8 sm:p-12 text-center bg-av-green-dark/30" style={{ backgroundColor: "rgba(22,56,29,0.3)" }}>
            <h2 className="font-display text-2xl sm:text-3xl text-av-white">La tua zona non è in elenco?</h2>
            <p className="mt-3 text-av-gray max-w-xl mx-auto">Operiamo anche nei comuni limitrofi. Contattaci per verificare se possiamo raggiungerti.</p>
            <div className="mt-7 flex flex-wrap justify-center gap-3">
              {settings && <a href={`tel:${settings.telefono_link}`} className="inline-flex items-center gap-2 rounded-full bg-av-bright text-av-black px-6 py-3 text-sm font-semibold hover:bg-av-lime transition-colors">Chiama il {settings.telefono}</a>}
              <WhatsAppButton variant="outline" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
